import _ from 'lodash';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { $ } from 'rype-bootstrap';

import { fetchServices } from '../../actions/serviceActions';
import ServiceGroupsSelector from '../../selectors/ServiceGroupsSelector';

import './LanguageSelect.css';

class LanguageSelect extends Component {
  constructor(props) {
    super(props);

    this.state = { selectedPlanLanguage: { id: 10, name: 'Spanish' } };

    $.noConflict();
  }

  componentWillMount() {
    if (_.isEmpty(this.props.serviceGroupsList)) {
      this.props.fetchServices();
    }
  }

  componentDidMount() {
    $('#service-plan-modal').on('shown.bs.modal', () => {
      $('#language-select-menu .dropdown-item').on('mousedown', event => {
        this.handleLanguageSelect(event);
      });

      // TODO: Add keyboard navigation when accessibility is fixed by Bootstrap
      // $('#language-select-menu .dropdown-item').on('select', (event)=> {
      //   this.handleLanguageSelect(event)
      // })
    });
  }

  handleLanguageSelect = (event) => {
    event.preventDefault();

    this.setState({
      selectedPlanLanguage: _.find(this.props.serviceGroupsList, [
        'id',
        parseInt(event.target.id, 10)
      ])
    });

    // TODO: do other stuff here....eg tell the parent to fetch the plan options
  }

  renderLanguageOptions() {
    const serviceGroups = _.sortBy(this.props.serviceGroupsList, serviceGroup => serviceGroup.name);

    // if no services are loaded yet
    if (serviceGroups.length < 1) {
      return <div> Loading.... </div>;
    }

    // build the list
    return serviceGroups.map(serviceGroup => {
      return (
        <a id={serviceGroup.id} className="dropdown-item" key={`serviceGroupId_${serviceGroup.id}`}>
          {serviceGroup.name}
        </a>
      );
    });
  }

  render() {
    return (
      <div className="LanguageSelect btn-group">
        <button
          type="button"
          className="btn btn-primary px-5"
        >
          {this.state.selectedPlanLanguage.name}
        </button>

        <button
          className="btn btn-primary dropdown-toggle dropdown-toggle-split"
          id="language-select-menu-button"
          type="button"
          data-toggle="dropdown"
          aria-haspopup="true"
          aria-expanded="false"
        >
          <span className="sr-only"> Toggle Dropdown </span>
        </button>

        <div
          id="language-select-menu"
          className="dropdown-menu"
          aria-labelledby="language-select-menu-button"
        >
          {this.renderLanguageOptions()}
        </div>
      </div>
    );
  }
}

function mapStateToProps(state) {
  return {
    serviceGroupsList: ServiceGroupsSelector(state)
  };
}

export default connect(mapStateToProps, { fetchServices })(LanguageSelect);



// WEBPACK FOOTER //
// ./src/components/LanguageSelect/LanguageSelect.js